// #72 (2026-08-04): single source of truth for the Cloud Functions origin.
// Previously constructed independently at 64 call sites across 34 files —
// a future project-ID env-var rename or region migration (see #57's
// onShiftDeleted precedent) meant editing all of them by hand. Every call
// site now imports this constant instead.
export const FUNCTIONS_ORIGIN = `https://australia-southeast1-${process.env.VUE_APP_FIREBASE_PROJECT_ID}.cloudfunctions.net`;
